import { useState, useRef, useEffect } from "react";
import { AuthData } from "../../auth/AuthWrapper";


export default function Header() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { logout } = AuthData();

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      className="h-16 flex items-center justify-between px-6 border-b border-slate-200 z-50"
      style={{ backgroundColor: "rgb(45, 62, 80)", position: "fixed", top: 0, left: 0, right: 0 }}
    >
      {/* Left */}
      <h1 className="text-white text-lg font-semibold"></h1>

      {/* Right */}
      <div className="flex items-center gap-4 relative" ref={dropdownRef}>
        {/* Avatar Button */}
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center justify-center h-8 w-8 rounded-full"
        >
          <div className="flex items-center justify-center h-8 w-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-700 text-white text-sm">
            {(localStorage.getItem("login_user_name") || "").charAt(0).toUpperCase()}
          </div>
        </button>

        {/* Dropdown */}
        {open && (
          <div className="absolute right-0 top-12 w-56 bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
            {/* Profile Info */}
            <div className="px-4 py-3 border-b">
              <p className="text-sm font-semibold text-gray-800">
                {localStorage.getItem("login_user_name")}
              </p>
              <p className="text-xs text-gray-500">
                {localStorage.getItem("organization")}
              </p>
            </div>

            {/* Menu Items */}
            {/* <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100">
              View Profile
            </button>

            <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100">
              Settings
            </button> */}

            <button
              className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
              onClick={logout}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}